import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { ReactiveFormsModule } from '@angular/forms';
import { MatAutocompleteModule } from '@angular/material/autocomplete';
import { MatCheckboxModule } from '@angular/material/checkbox';
import { MatIconModule } from '@angular/material/icon';
import { MatInputModule } from '@angular/material/input';
import { MatSelectModule } from '@angular/material/select';
import { RouterModule } from '@angular/router';
import { NgbDropdownModule } from '@ng-bootstrap/ng-bootstrap';
import { NgSelectModule } from '@ng-select/ng-select';
import { CmsConfig, I18nModule, provideConfig } from '@spartacus/core';
import { GlobalMessageComponentModule } from '@spartacus/storefront';
import { SharedModule } from 'src/app/shared/shared.module';
import { NotAuthGuard } from './guards/not-auth.guard';
import { LoginComponent } from './login.component';

@NgModule({
  declarations: [LoginComponent],
  imports: [
    CommonModule,
    GlobalMessageComponentModule,
    I18nModule,
    NgSelectModule,
    ReactiveFormsModule,
    MatSelectModule,
    MatCheckboxModule,
    MatInputModule,
    MatIconModule,
    MatAutocompleteModule,
    RouterModule,
    SharedModule,
    NgbDropdownModule,
  ],
  providers: [
    provideConfig(<CmsConfig>{
      cmsComponents: {
        LoginFormComponent: {
          component: LoginComponent,
          guards: [NotAuthGuard],
        },
      },
    }),
  ],
  exports: [LoginComponent],
})
export class LoginModule {}
